module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-journals-family"
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "float-right",
    attrs: {
      "src": _vm.getStaticPath(_vm.rapamycinLogo),
      "alt": "Rapamycin Logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, [_vm._l((_vm.sortedList), function(site) {
    return [_c('b-nav-item', [_vm._v(_vm._s(site.name))])]
  })], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pt-3 pr-3 d-inline-block"
  }, [_vm._v("\n        Visit the Rapamycin Family of "), _c('br'), _vm._v(" Medical Science Journals\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b1a0a46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/footer-area/journals-family/FooterJournalsFamilyComponent.vue
// module id = 1459
// module chunks = 1